(function () {
  const drawerId = 'Cart-Drawer';

  const addOne = async (variantId) => {
    const res = await fetch(`${theme.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });
    return res.ok;
  };

  const onClick = async (e) => {
    const btn = e.target.closest('.reco-addone[data-variant-id]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    // Doppelklick-Schutz
    if (btn.dataset.loading === '1') return;
    btn.dataset.loading = '1';

    // Optional: Loader (falls vorhanden)
    btn.querySelector('.loading-overlay')?.classList.add('active');

    const ok = await addOne(btn.dataset.variantId);

    btn.querySelector('.loading-overlay')?.classList.remove('active');
    btn.dataset.loading = '0';

    if (ok) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  };

  const init = () => {
    const drawer = document.getElementById(drawerId);
    if (!drawer) return;

    // wichtig: delegation, weil recommendations nach refresh neu gerendert werden
    drawer.addEventListener('click', onClick, true);
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('cart-drawer:open', () => setTimeout(init, 50));
})();
